<!--Drawing tool buttons-->
<div #drawingTool class="drawing-tools-box" cdkDrag cdkDragBoundary=".map-frame">
  <div
    class="drawing-tool-icon-container"
    (click)="toggleDraw(figureTypes.POINT)"
    [ngClass]="{ 'figure-selected': drawingFigure == figureTypes.POINT }"
    *ngIf="options.point"
  >
    <button
      mat-icon-button
      aria-label="Point Button"
      color="accent"
      [disabled]="isEditing || isDrawing"
      [matTooltip]="'map.drawing_tool.point' | translate"
      matTooltipPosition="below"
    >
      <mat-icon>circle</mat-icon>
    </button>
  </div>

  <div
    class="drawing-tool-icon-container"
    (click)="toggleDraw(figureTypes.LINE)"
    [ngClass]="{ 'figure-selected': drawingFigure == figureTypes.LINE }"
    *ngIf="options.line"
  >
    <button
      mat-icon-button
      aria-label="Polygon Button"
      color="accent"
      [disabled]="isEditing || isDrawing"
      [matTooltip]="'map.drawing_tool.line' | translate"
      matTooltipPosition="below"
      matTooltipShowDelay="500"
    >
      <mat-icon>remove</mat-icon>
    </button>
  </div>

  <div
    class="drawing-tool-icon-container"
    (click)="toggleDraw(figureTypes.POLYGON)"
    [ngClass]="{ 'figure-selected': drawingFigure == figureTypes.POLYGON }"
    *ngIf="options.polygon"
  >
    <button
      mat-icon-button
      aria-label="Polygon Button"
      color="accent"
      [disabled]="isEditing || isDrawing"
      [matTooltip]="'map.drawing_tool.polygon' | translate"
      matTooltipPosition="below"
      matTooltipShowDelay="500"
    >
      <mat-icon>pentagon</mat-icon>
    </button>
  </div>

  <div
    class="drawing-tool-icon-container"
    (click)="toggleDraw(figureTypes.CIRCLE)"
    [ngClass]="{ 'figure-selected': drawingFigure == figureTypes.CIRCLE }"
    *ngIf="options.circle"
  >
    <button
      mat-icon-button
      aria-label="Circle Button"
      color="accent"
      [disabled]="isEditing || isDrawing"
      [matTooltip]="'map.drawing_tool.circle' | translate"
      matTooltipPosition="below"
      matTooltipShowDelay="500"
    >
      <mat-icon>adjust</mat-icon>
    </button>
  </div>

  <div
    class="drawing-tool-icon-container"
    (click)="toggleDraw(figureTypes.TEXT)"
    [ngClass]="{ 'figure-selected': drawingFigure == figureTypes.TEXT }"
    *ngIf="options.text"
  >
    <button
      mat-icon-button
      aria-label="Text Button"
      color="accent"
      [disabled]="isEditing || isDrawing"
      [matTooltip]="'map.drawing_tool.text' | translate"
      matTooltipPosition="below"
      matTooltipShowDelay="500"
    >
      <mat-icon>text_fields</mat-icon>
    </button>
  </div>

  <div class="drawing-tool-icon-container">
    <button
      mat-icon-button
      aria-label="Undo Button"
      color="accent"
      [matTooltip]="'common.undo' | translate"
      matTooltipPosition="below"
      matTooltipShowDelay="500"
      [disabled]="operations.length == 0 || isEditing"
      (click)="undoOperation()"
    >
      <mat-icon>undo</mat-icon>
    </button>
  </div>

  <div (click)="closeDrawingTool()" class="drawing-tool-icon-container">
    <button
      mat-icon-button
      aria-label="Closing button"
      color="warn"
      [matTooltip]="'common.close' | translate"
      matTooltipPosition="below"
      matTooltipShowDelay="500"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div cdkDragHandle>
    <button mat-icon-button aria-label="Drag Handle" style="cursor: move" color="accent">
      <mat-icon>open_with</mat-icon>
    </button>
  </div>
</div>
<!--END Drawing tool buttons-->

<!--Drawing tool edit view-->
<div cdkDrag cdkDragBoundary=".map-frame" class="drawing-edit-box" *ngIf="drawingEditOpen">

  <div class="drawing-edit-header" cdkDragHandle>
    <span>{{ editDrawingTitle }}</span>
  </div>

  <div class="d-flex flex-column gap-3 drawing-edit-content">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>{{ 'map.drawing_tool.drawing_name' | translate }}</mat-label>
      <input [(ngModel)]="generalOptions.geometryName" matInput maxlength="255" />
    </mat-form-field>

    <mat-form-field class="w-100" appearance="outline">
      <mat-label>{{ 'map.drawing_tool.reference_system' | translate }}</mat-label>
      <mat-select [(ngModel)]="generalOptions.EPSG" (selectionChange)="updateCoordinates()">
        <mat-option *ngFor="let epsg of EPSG_VALUES" [value]="epsg.value">{{ epsg.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- <mat-divider class="mb-2"></mat-divider> -->

    <div class="custom-form" *ngIf="drawingFigure == figureTypes.POINT">
      <span class="d-block my-2">{{ 'map.drawing_tool.position' | translate }}</span>
      <div class="coordinate-container">
        <mat-form-field appearance="outline">
          <mat-label>X</mat-label>
          <input
            [placeholder]="'map.drawing_tool.meters' | translate"
            type="number"
            (input)="manualUpdatePoint()"
            [(ngModel)]="pointOptions.coordinate[0]"
            matInput
          />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Y</mat-label>
          <input
            [placeholder]="'map.drawing_tool.meters' | translate"
            type="number"
            (input)="manualUpdatePoint()"
            [(ngModel)]="pointOptions.coordinate[1]"
            matInput
          />
        </mat-form-field>
      </div>
    </div>
    <div class="custom-form" *ngIf="drawingFigure == figureTypes.LINE">
      <div class="row measures-row">
        <div class="col-12">
          <span class="d-block my-2">{{ 'map.drawing_tool.length' | translate }}</span>
          <br />
          <span>{{ calculateLength() }}</span>
        </div>
      </div>
      <span class="d-block my-2">{{ 'map.drawing_tool.coordinates' | translate }}</span>
      <div class="d-flex flex-column gap-2 justify-content-between">
        <div class="coordinate-container" *ngFor="let point of lineOptions.coordinates; let i = index">
          <div class="w-10">
            <span class="point-index-badge">{{ (i + 1) }}</span>
          </div>
          <mat-form-field appearance="outline">
            <mat-label>X</mat-label>
            <input type="number" (input)="manualUpdateLine()" [(ngModel)]="point[0]" matInput>
          </mat-form-field>
          <mat-form-field  appearance="outline">
            <mat-label>Y</mat-label>
            <input type="number" (input)="manualUpdateLine()" [(ngModel)]="point[1]" matInput>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="custom-form" *ngIf="drawingFigure == figureTypes.POLYGON">
      <div class="row measures-row">
        <div class="col-6">
          <span class="d-block my-2">{{ 'map.drawing_tool.perimeter' | translate }}</span>
          <br />
          <span>{{ calculateLength() }}</span>
        </div>
        <div class="col-6">
          <span class="d-block my-2">{{ 'map.drawing_tool.area' | translate }}</span>
          <br />
          <span>{{ calculateArea() }}</span>
        </div>
      </div>
      <span class="d-block my-2">{{ 'map.drawing_tool.coordinates' | translate }}</span>
      <div class="d-flex flex-column gap-2 justify-content-between">
        <div class="coordinate-container" *ngFor="let point of polygonOptions.coordinates; let i = index">
          <div class="w-10">
            <span class="point-index-badge">{{ (i + 1) }}</span>
          </div>
          <mat-form-field appearance="outline">
            <mat-label>X</mat-label>
            <input type="number" (input)="manualUpdatePolygon()" [(ngModel)]="point[0]" matInput>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Y</mat-label>
            <input type="number" (input)="manualUpdatePolygon()" [(ngModel)]="point[1]" matInput>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="custom-form" *ngIf="drawingFigure == figureTypes.CIRCLE">
      <div class="row measures-row">
        <div class="col-6">
          <span class="d-block my-2">{{ 'map.drawing_tool.circumference' | translate }}</span>
          <br />
          <span>{{ calculateLength() }}</span>
        </div>
        <div class="col-6">
          <span class="d-block my-2">{{ 'map.drawing_tool.area' | translate }}</span>
          <br />
          <span>{{ calculateArea() }}</span>
        </div>
      </div>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>{{ 'map.drawing_tool.radius' | translate }}</mat-label>
        <input type="number" (input)="manualUpdateCircle()" [(ngModel)]="circleOptions.radius" matInput />
      </mat-form-field>

      <span class="d-block my-2">{{ 'map.drawing_tool.center' | translate }}</span>
      <div class="coordinate-container">
        <mat-form-field appearance="outline">
          <mat-label>X</mat-label>
          <input type="number" (input)="manualUpdateCircle()" [(ngModel)]="circleOptions.center[0]" matInput />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Y</mat-label>
          <input type="number" (input)="manualUpdateCircle()" [(ngModel)]="circleOptions.center[1]" matInput />
        </mat-form-field>
      </div>
    </div>
    <div class="custom-form" *ngIf="drawingFigure == figureTypes.TEXT">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>{{ 'map.drawing_tool.text_label' | translate }}</mat-label>
        <input
          [placeholder]="'map.drawing_tool.meters' | translate"
          type="text"
          (input)="manualUpdateText()"
          [(ngModel)]="textOptions.label"
          matInput
        />
      </mat-form-field>

      <span class="d-block my-2">{{ 'map.drawing_tool.position' | translate }}</span>
      <div class="d-flex flex-column gap-2 justify-content-between">
        <div class="coordinate-container">
          <mat-form-field appearance="outline">
            <mat-label>X</mat-label>
            <input type="number" (input)="manualUpdateText()" [(ngModel)]="textOptions.position[0]" matInput>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Y</mat-label>
            <input type="number" (input)="manualUpdateText()" [(ngModel)]="textOptions.position[1]" matInput>
          </mat-form-field>
        </div>

        <mat-form-field class="w-100" appearance="outline">
          <mat-label>{{ 'map.drawing_tool.text_font_type' | translate }}</mat-label>
          <mat-select [(ngModel)]="textOptions.fontType" (selectionChange)="manualUpdateText()">
            <mat-option *ngFor="let type of FONT_TYPE_VALUES" [value]="type.value">{{type.label}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="w-100" appearance="outline">
          <mat-label>{{ 'map.drawing_tool.text_font_weight' | translate }}</mat-label>
          <mat-select [(ngModel)]="textOptions.fontWeight" (selectionChange)="manualUpdateText()">
            <mat-option *ngFor="let weight of FONT_WEIGHT_VALUES" [value]="weight.value">{{weight.label}}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="coordinate-container justify-content-between">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{ 'map.drawing_tool.text_font_size' | translate }}</mat-label>
            <input placeholder="16" type="number" (input)="manualUpdateText()" [(ngModel)]="textOptions.fontSize" matInput>
          </mat-form-field>
    
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{ 'map.drawing_tool.unit' | translate }}</mat-label>
            <mat-select [(ngModel)]="textOptions.fontSizeUnit" (selectionChange)="manualUpdateText()">
              <mat-option value="px">{{ 'map.drawing_tool.unit_pixels' | translate }}</mat-option>
              <mat-option value="m">{{ 'map.drawing_tool.unit_meters' | translate }}</mat-option>
            </mat-select>
            <!-- <mat-hint align="end">Here's the dropdown arrow ^</mat-hint> -->
          </mat-form-field>
        </div>

        <div class="coordinate-container justify-content-between">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{ 'map.drawing_tool.text_color' | translate }}</mat-label>
            <input placeholder="#fff" type="color" (input)="manualUpdateText()" [(ngModel)]="textOptions.color" matInput>
          </mat-form-field>
  
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{ 'map.drawing_tool.text_border_color' | translate }}</mat-label>
            <input placeholder="#000" type="color" (input)="manualUpdateText()" [(ngModel)]="textOptions.borderColor"
              matInput>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-between gap-2 negative-x-margin-10">
    <button class="add-layer-btn w-100" mat-flat-button color="warn" (click)="deleteDraw()" *ngIf="isEditing">
      <mat-icon>delete</mat-icon> <span>{{ 'common.remove' | translate }}</span>
    </button>
  </div>
  <div class="d-flex justify-content-between gap-2 negative-x-margin-10">
    <button class="add-layer-btn w-100" mat-stroked-button color="primary" (click)="cancelDraw()">
      <mat-icon>block</mat-icon> <span>{{ 'common.cancel' | translate }}</span>
    </button>

    <button class="add-layer-btn w-100" mat-flat-button color="primary" (click)="confirmCurrentDraw()">
      <mat-icon>check</mat-icon> <span>{{ 'common.confirm' | translate }}</span>
    </button>
  </div>
</div>
<!--END Drawing tool buttons-->

<div id="select-popup" class="select-popup">
  <h4 class="p-2 text-center m-0">{{ 'map.drawing_tool.select_geometry_edit' | translate }}</h4>
  <a id="select-popup-close" class="select-popup-close" (click)="closeSelectPopup()"></a>
  <div id="select-popup-content">
    <ul class="select-popup-list">
      <li
        class="select-popup-list-element"
        *ngFor="let feature of selectedFeatures"
        (click)="selectFromPopup(feature)"
        (mouseenter)="hoverSelected(feature)"
        (mouseleave)="removeHoverStyle(feature)"
      >
        {{ feature.get('name') }}
      </li>
    </ul>
  </div>
</div>
